import { render, staticRenderFns } from "./EditPlanPermissions.vue?vue&type=template&id=037e80f8&"
import script from "./EditPlanPermissions.vue?vue&type=script&lang=js&"
export * from "./EditPlanPermissions.vue?vue&type=script&lang=js&"
import style0 from "./EditPlanPermissions.vue?vue&type=style&index=0&id=037e80f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports